import { useQuery } from "@tanstack/react-query";
import useAuth from "hooks/useAuth";
import { fetchAdminData } from "../Services/fetchAdminData";
import { useBoundStore } from "useStore";

export default function useAdminData({ countryId, fullData, stateOverride, enabled: enabledProp }) {
  const { accessToken } = useAuth();
  const searchObject = useBoundStore((state) => state.soAdminSearch);
  const search = searchObject.searchTerm;
  const startDate = searchObject.startDate;
  const endDate = searchObject.endDate;
  const paginationModel = useBoundStore(
    (state) => state.soAdminPaginationModel,
  );
  const page = paginationModel.page;
  const pageSize = paginationModel.pageSize;
  const selectedStatus = useBoundStore((state) => state.soAdminSelectedStatus);
  const estadoIdFromStore = selectedStatus?.id;

  const isExportMode = fullData === true;
  const effectiveEstadoId = isExportMode
    ? stateOverride === "all"
      ? undefined
      : stateOverride
    : estadoIdFromStore;

  return useQuery({
    queryKey: [
      "serviceOperation",
      "adminData",
      {
        countryId,
        estadoId: effectiveEstadoId,
        page: isExportMode ? 0 : page,
        pageSize: isExportMode ? 0 : pageSize,
        search,
        startDate,
        endDate,
        fullData,
      },
    ],
    queryFn: () =>
      fetchAdminData({
        accessToken,
        countryId,
        estadoId: effectiveEstadoId,
        page: isExportMode ? 0 : page,
        pageSize: isExportMode ? 0 : pageSize,
        search,
        startDate,
        endDate,
        fullData,
      }),
    staleTime: Infinity,
    enabled: enabledProp !== undefined
      ? enabledProp
      : isExportMode
        ? !!countryId && !!accessToken
        : !!countryId && !!estadoIdFromStore && !!accessToken,
    retry: false,
    placeholderData: (previousData) => previousData,
  });
}
